<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Foreword">
<div class="titlepage">
<div>
<div>
<h1 class="title" style="color: #778f4f;"><a id="d0e87" xmlns:saxon="http://icl.com/saxon">Foreword</a></h1><a id="d0e87" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e87" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e87" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e87" xmlns:saxon="http://icl.com/saxon">
<p><span class="DropCap" style="color: #778f4f;">W</span> orking from his base in Palm Springs, Christopher Kennedy’s
        name has become synonymous with midcentury California glamour. His work with modernism has
        catapulted the design medium to the forefront of our community’s consciousness. He’s taken a
        venue that is often misinterpreted and simplified the process of creating midcentury design
        in the home with his clear vision. </p>
<p>Having had the opportunity to work with Christopher, he has become a great friend and
        colleague of mine. He and I share a deep-seated passion for couture and the great fashion
        houses of Europe, and it’s through our love of this medium that we both find incredible joy
        and the heart of our creativity within our design work. </p>
<p>It’s a tremendous thrill and an honor to have been asked to write this foreword.
        Christopher is a man with incredible vision who is extremely confident and accomplished. I
        predict that you’ll find some inspiration here to spark your own creativity. </p>
<p>Barclay Butera</p>
<div class="mediaobject" title="Photo of interior of home.">
<img alt="Photo of interior of home." src="images/0072_MMM.jpg"/>
</div>
<div class="mediaobject" title="Photo of fireplace.">
<img alt="Photo of fireplace." src="images/0027_MMM.jpg"/>
</div>
</a></div><a id="d0e87" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?7bc44bb9